import { gql } from 'apollo-angular';

export const HIGH_SCHOOL_SALARY_DOCUMENT = gql`
  query HighSchoolCipCodeSalaries {
    highSchoolCipCodeSalaries {
      avgAMedian
      avgAPct25
    }
  }
`;
